<template>
  <div>
    <div ref="expandable" class="expandable" :style="`max-height: ${expanded ? normalHeight + 'px' : maxHeight + 'px'}`">
      <slot />
    </div>

    <slot name="read-more" v-bind="{ expandable, expanded, toggle }">
      <button class="read-more flex mx-auto my-1 cursor-pointer items-center" v-if="expandable" @click.prevent="toggle">
        {{ expanded ? 'Show less' : 'Read more' }}

        <img src="/images/down.svg" :class="{ 'rotate-180' : expanded }">
      </button>
    </slot>
  </div>
</template>

<script>
  export default {
    props: {
      maxHeight: {
        type: Number,
        default: 320,
      },
    },

    data () {
      return {
        expanded: false,
        expandable: false,
        normalHeight: 10000,
      }
    },

    mounted () {
      const normalHeight = this.$refs.expandable.scrollHeight
      this.expandable = normalHeight > this.maxHeight

      if(this.normalHeight <= this.maxHeight) {
          this.normalHeight = normalHeight
          this.expandable = false;
      }


    },

    methods: {
      toggle () {
        this.expanded = !this.expanded
      },
    },
  }
  </script>

  <style scoped lang="scss">
  .expandable {
    overflow-y: hidden;
    // transition: max-height 0.25s linear;
  }

  .expandable-text {

    img.icon {
      height: 12px;
      width: 12px;
      margin: 10px auto 0 0;

      cursor: pointer;
    }
  }

  .read-more {
    font-size: 12.5px;
    letter-spacing: 0;
    line-height: 20px;

    img {
      width: 15px;

      &.rotate-180 {
        transform: rotate(180deg);
      }
    }
  }
  </style>
